/** localStorage that never throws: a private window or blocked site data just means
 * nothing is remembered. */
export const storage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Not remembered.
    }
  },
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // Nothing stored.
    }
  },
};

/** One id per browser, the web's version of the phone's device id. */
export function deviceID(): string {
  const key = "radiola.device-id";
  const existing = storage.get(key);
  if (existing) return existing;
  const created = `web-${crypto.randomUUID()}`;
  storage.set(key, created);
  return created;
}
